module.exports = __webpack_public_path__ + "img/feature_buy_id.9652e0a6.png";